import axios from 'axios'

const API_URL = `${process.env.REACT_APP_API_URL}`

const ConwxPortfolio = {
  getConwxPortfolio({ force = false } = {}) {
    return axios({
      method: 'get',
      url: `${API_URL}/conwx_portfolio`,
      params: force ? { force: true } : {},
    })
  },
}

export default ConwxPortfolio
